<template>
  <div class="tab-container">
    <ul class="tab-head">
      <slot></slot>
    </ul>
    <j-content-container :panels="panels" />
  </div>
</template>

<script>
import JContentContainer from "./JContentContainer";
export default {
  name: "JTabs",
  data() {
    return {
      panels: []
    };
  },
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    tabChange(index) {
      this.$emit("tabChange", index);
    }
  },
  components: {
    JContentContainer
  }
};
</script>

<style scoped>
.tab-container {
}
.tab-head {
  padding: 0 5px;
  font-size: 0;
}
</style>
